import { ICountry } from '../../models/country'

export enum VerificationTypeKeys {
  CLEAR_VERIFICATION_FIELDS = 'CLEAR_VERIFICATION_FIELDS',
  SET_VERIFICATION_DNI = 'SET_VERIFICATION_DNI',
  SET_VERIFICATION_CODE = 'SET_VERIFICATION_CODE',
  CONFIRM_VERIFICATION_CODE = 'CONFIRM_VERIFICATION_CODE',
  CONFIRMING_VERIFICATION_CODE = 'CONFIRMING_VERIFICATION_CODE',
  CONFIRM_VERIFICATION_CODE_SUCCESSFUL = 'CONFIRM_VERIFICATION_CODE_SUCCESSFUL',
  CONFIRM_VERIFICATION_CODE_FAILED = 'CONFIRM_VERIFICATION_CODE_FAILED',
  SET_VERIFICATION_EMAIL = 'SET_VERIFICATION_EMAIL',
  SET_VERIFICATION_PHONE = 'SET_VERIFICATION_PHONE',
  SET_VERIFICATION_CALLING_CODE = 'SET_VERIFICATION_CALLING_CODE',
  SET_VERIFICATION_COUNTRY = 'SET_VERIFICATION_COUNTRY',
  RESEND_VERIFICATION_CODE = 'RESEND_VERIFICATION_CODE',
  RESENDING_VERIFICATION_CODE = 'RESENDING_VERIFICATION_CODE',
  RESEND_VERIFICATION_CODE_SUCCESSFUL = 'RESEND_VERIFICATION_CODE_SUCCESSFUL',
  RESEND_VERIFICATION_CODE_FAILED = 'RESEND_VERIFICATION_CODE_FAILED',
  SET_VERIFICATION_ORIGIN = 'SET_VERIFICATION_ORIGIN'
}

export type VerificationOrigin = 'signUp' | 'signIn' | 'recoverPassword'

export interface IClearVerificationFieldsAction {
  type: VerificationTypeKeys.CLEAR_VERIFICATION_FIELDS
  [extraProps: string]: unknown
}

export interface ISetVerificationDNIAction {
  type: VerificationTypeKeys.SET_VERIFICATION_DNI
  payload: string
  [extraProps: string]: unknown
}

export interface ISetVerificationCodeAction {
  type: VerificationTypeKeys.SET_VERIFICATION_CODE
  payload: string
  [extraProps: string]: unknown
}

export interface IConfirmVerificationCodeAction {
  type: VerificationTypeKeys.CONFIRM_VERIFICATION_CODE
  [extraProps: string]: unknown
}

export interface ISetIsConfirmingVerificationCodeAction {
  type: VerificationTypeKeys.CONFIRMING_VERIFICATION_CODE
  [extraProps: string]: unknown
}

export interface IConfirmVerificationCodeSuccessfulAction {
  type: VerificationTypeKeys.CONFIRM_VERIFICATION_CODE_SUCCESSFUL
  [extraProps: string]: unknown
}

export interface IConfirmVerificationCodeFailedAction {
  type: VerificationTypeKeys.CONFIRM_VERIFICATION_CODE_FAILED
  [extraProps: string]: unknown
}

export interface ISetVerificationEmailAction {
  type: VerificationTypeKeys.SET_VERIFICATION_EMAIL
  payload: string
  [extraProps: string]: unknown
}

export interface ISetVerificationPhoneAction {
  type: VerificationTypeKeys.SET_VERIFICATION_PHONE
  payload: string
}

export interface ISetVerificationCallingCodeAction {
  type: VerificationTypeKeys.SET_VERIFICATION_CALLING_CODE
  payload: string
}

export interface ISetVerificationCountryAction {
  type: VerificationTypeKeys.SET_VERIFICATION_COUNTRY
  payload: ICountry
}

export interface IResendVerificationCodeAction {
  type: VerificationTypeKeys.RESEND_VERIFICATION_CODE
  [extraProps: string]: unknown
}

export interface ISetIsResendingVerificationCodeAction {
  type: VerificationTypeKeys.RESENDING_VERIFICATION_CODE
  [extraProps: string]: unknown
}

export interface IResendVerificationCodeSuccessfulAction {
  type: VerificationTypeKeys.RESEND_VERIFICATION_CODE_SUCCESSFUL
  [extraProps: string]: unknown
}

export interface IResendVerificationCodeFailedfulAction {
  type: VerificationTypeKeys.RESEND_VERIFICATION_CODE_FAILED
  [extraProps: string]: unknown
}

export interface ISetVerificationOriginAction {
  type: VerificationTypeKeys.SET_VERIFICATION_ORIGIN
  payload: VerificationOrigin | null
}

export type VerificationActionTypes =
  | IClearVerificationFieldsAction
  | ISetVerificationDNIAction
  | ISetVerificationCodeAction
  | IConfirmVerificationCodeAction
  | ISetIsConfirmingVerificationCodeAction
  | IConfirmVerificationCodeSuccessfulAction
  | IConfirmVerificationCodeFailedAction
  | ISetVerificationEmailAction
  | ISetVerificationPhoneAction
  | ISetVerificationCallingCodeAction
  | ISetVerificationCountryAction
  | IResendVerificationCodeAction
  | ISetIsResendingVerificationCodeAction
  | IResendVerificationCodeSuccessfulAction
  | IResendVerificationCodeFailedfulAction
  | ISetVerificationOriginAction
